module.exports = __webpack_public_path__ + "img/rt-logo.40765089.svg";